import { authFetch } from './client';

export const getCurrentOrg = () => authFetch('/api/orgs/current');
export const listOrgs = () => authFetch('/api/orgs');
export const getOrg = (orgId) => authFetch(`/api/orgs/${orgId}`);
export const createOrg = (name) =>
  authFetch('/api/orgs', { method: 'POST', body: JSON.stringify({ name }) });
export const renameOrg = (orgId, name) =>
  authFetch(`/api/orgs/${orgId}`, { method: 'PATCH', body: JSON.stringify({ name }) });
export const getSeatUsage = (orgId) => authFetch(`/api/orgs/${orgId}/seats`);
// Concurrent worker-job queue (a "seat" = one running worker job).
export const listOrgJobs = (orgId) => authFetch(`/api/orgs/${orgId}/jobs`);
export const killOrgJob = (orgId, jobId) =>
  authFetch(`/api/orgs/${orgId}/jobs/${jobId}`, { method: 'DELETE' });
export const killMyOrgJobs = (orgId) => authFetch(`/api/orgs/${orgId}/jobs`, { method: 'DELETE' });
// Org-wide AGENT activity (LLM calls). Sibling of /jobs: an agent consumes no
// worker-job seat, so it appears in none of the CPU/GPU accounting above.
export const listOrgAgents = (orgId) => authFetch(`/api/orgs/${orgId}/agents`);
// Only a durable server run is stoppable; browser-driven rounds come back with
// `stoppable: false` and finish on their own.
export const stopOrgAgent = (orgId, agentId) =>
  authFetch(`/api/orgs/${orgId}/agents/${encodeURIComponent(agentId)}`, { method: 'DELETE' });
export const stopMyOrgAgents = (orgId) =>
  authFetch(`/api/orgs/${orgId}/agents`, { method: 'DELETE' });
// Priced usage history (admin+ — VIEW_COSTS, unlike the member-rank VIEW_JOBS
// above: this payload names every member and what they spent). ESTIMATES from a
// rate table the backend maintains, not AWS's bill — the response carries
// `estimated` and `ratesAsOf`, and the UI must keep saying so.
export const getOrgCosts = (orgId, days = 30) => authFetch(`/api/orgs/${orgId}/costs?days=${days}`);
// Storage is its OWN call because it walks S3 per member while /costs is a single
// DynamoDB query — fetched separately so a slow inventory never delays the trend.
export const getOrgStorageCost = (orgId) => authFetch(`/api/orgs/${orgId}/costs/storage`);
